import { render, staticRenderFns } from "./PostalCodeColumn.vue?vue&type=template&id=d8f3877e&"
import script from "./PostalCodeColumn.vue?vue&type=script&lang=js&"
export * from "./PostalCodeColumn.vue?vue&type=script&lang=js&"
import style0 from "./PostalCodeColumn.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8f3877e')) {
      api.createRecord('d8f3877e', component.options)
    } else {
      api.reload('d8f3877e', component.options)
    }
    module.hot.accept("./PostalCodeColumn.vue?vue&type=template&id=d8f3877e&", function () {
      api.rerender('d8f3877e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/table/PostalCodeColumn.vue"
export default component.exports